import { Component, ViewChild } from '@angular/core';
import { MatPaginator as MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource as MatTableDataSource, MatTableModule } from '@angular/material/table';
import { TranslateHelper } from '@app/_helpers';
import { AuthenticationService } from '@app/_services';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { PropertyService } from '@app/_services/property.service';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { CurrencyFormatPipe } from '../../../../../shared/pipes/currency-format.pipe';
import { NgIf, DatePipe } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-page-property-list',
    templateUrl: './page-property-list.component.html',
    styleUrls: ['./page-property-list.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [FormsModule, MatInputModule, NgIf, MatTableModule, RouterLink, MatPaginatorModule, DatePipe, CurrencyFormatPipe, TranslateModule]
})
export class PagePropertyListComponent  {

  userDetails;
    constructor(private authService: AuthenticationService, public propertyService: PropertyService,
        private toastr: ToastrService, public translate: TranslateService,
        public translateHelper: TranslateHelper,private route: ActivatedRoute) {}

    displayedColumns: string[] = ['id', 'property','contractType', 'startDate', 'endDate', 'lastInvoiceDate','lastInvoicePrice', 'balance' ];
    dataSource: MatTableDataSource<any>;
    pageType="property";
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    ngOnInit(): void {
        this.authService.currentUser.subscribe((user): any => {
            this.userDetails = user;
        });
        this.pageType = this.route.snapshot.data['feature'];

        this.loadQuotations();
    }

    status = {
        new: {
            color: '#125077',
            text: 'New',
        },
        open: {
            color: '#9E6DEB',
            text: 'Open',
        },
        offered: {
            color: '#ff5900',
            text: 'Offered',
        },
        accepted: {
            color: '#079008',
            text: 'Accepted',
        },
        inprogress: {
            color: '#6D9EEB',
            text: 'In-Progress',
        },
        rejected: {
            color: '#ff0202',
            text: 'Rejected',
        },

        cancelled: {
            color: '#ff0202',
            text: 'Cancelled',
        },
        renegotiated: {
            color: '#0095a0',
            text: 'Renegotiated',
        },
    };

    loadQuotations() {
        this.dataSource = new MatTableDataSource;
        this.dataSource.data = [];
        this.propertyService.getPropertylist(this.pageType) .subscribe(data=>{
            if(data?.data)
            this.dataSource.data = data.data;
            else
            this.toastr.error('Error getting Data')
        }, (error)=>{
            console.error(error);
        });
    }

    getContractType(type) {
        if(type == 'management'){
            return "Managment"
        }else if(type == 1){
            return "Rent"
        }
    }

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

}
